export default {
  today: '今天',
  yesterday: '昨天',
  'ticket.list.status_pending': '新的',
  'ticket.list.status_working': '在处理中',
  'ticket.list.status_closed': '已关闭',
  'ticket.list.status_unknown': '未知',
  'ticket.list.id': '%2的#%1',
  'deposit.min_msg': '最低充值金额为%1%2',
  'legal_entity.status_new': 'В обработке',
  'legal_entity.status_approved': 'Подтверждено',
  'legal_entity.status_declined': 'Отклонено',
  'legal_entity.invoice.status_new': 'В обработке',
  'legal_entity.invoice.paid': 'Оплачено',
  'access.role_managers.title': '管理员',
  'access.role_reporters.title': '观察员',
  'partner_payment.status_pending': '正在进行中',
  'partner_payment.status_paused': '暂停',
  'partner_payment.status_error': '错误',
  'partner_payment.status_success': '已处理',
  'partner_payment.status_cancelled': '已取消',
  'partner_payment.status_declined': '已拒绝',
  'billing_profile.payment.method.epayments': 'ePayments',
  'billing_profile.payment.method.juridical': '法人',
  'billing_profile.payment.method.qiwi': 'QIWI',
  'billing_profile.payment.method.paymaster': 'WebMoney',
  'billing_profile.payment.method.paymaster_ru': 'WebMoney WMP',
  'billing_profile.payment.method.paypal': 'PayPal',
  'billing_profile.payment.method.lucky': 'Lucky.online',
  'billing_profile.payment.method.stripe': '国际银行卡',
  'billing_profile.payment.method.winpay': 'WinPay',
  'billing_profile.payment.method.tinkoff': 'Tinkoff',
  'billing_profile.payment.method.paymaster_service': 'Paymaster',
  'billing_profile.withdrawal.method.bank_card': '银行卡',
  'billing_profile.withdrawal.method.webmoney': 'WebMoney',
  'billing_profile.withdrawal.method.epayments': 'ePayments',
  'billing_profile.status_new': '在审核中',
  'billing_profile.status_pending': '在处理中',
  'billing_profile.status_approved': '已确认',
  'billing_profile.status_declined': '已拒绝',
  'payment_profile.epayments.tax_number_label': '税号',
  'payment_profile.epayments.ru_tax_number_label': '纳税人识别号',
  'payment_profile.paymaster.tax_number_label': '税号',
  'payment_profile.paymaster.ru_tax_number_label': '纳税人识别号',
  'payment_profile.qiwi.tax_number_label': '税号',
  'payment_profile.qiwi.ru_tax_number_label': '纳税人识别号',
  'invoice.status.new': '新的',
  'invoice.status.pending': '在处理中',
  'invoice.status.waiting': '等待付款',
  'invoice.status.paid': '已付款',
  'invoice.title': '%2的%1',
  'invoice.title_new': '新的帐单',
  'invoice.title_id': '帐单№%%1',
  'payment_profile.juridical.contact_person_label': 'Contact Person',
  'payment_profile.juridical.phone_label': 'Phone No.',
  'payment_profile.juridical.email_label': 'Email address',
  'payment_profile.juridical.currency_label': 'Invoice currency',
  'payment_profile.juridical.tax_number_local_label': '纳税人识别号',
  'payment_profile.juridical.tax_number_foreign_label': 'VAT number',
  'payment_profile.juridical.juridical_address_local_label': '法定地址',
  'payment_profile.juridical.juridical_address_foreign_label': 'Registered Address',
  'payment_profile.juridical.actual_address_local_label': '实际地址',
  'payment_profile.juridical.actual_address_foreign_label': 'Communication Address',
  'credit.title': 'Deferred payment #%1',
  'credit.status_pending': 'Pending',
  'credit.status_approved': 'Approved',
  'credit.status_declined': 'Declined',
  'credit.status_repaid': 'Repaid',
  'yandex_subscription.campaign.budget': '%1 %2',
  'yandex_subscription.campaign.prediction': 'Approximately %1 potential customers per month',
  'yandex_subscription.campaign.benefit': 'save on',
  'yandex_subscription.campaign.budgetType_WEB_MINIMAL': 'Minimal',
  'yandex_subscription.campaign.budgetType_WEB_MAXIMAL': 'Maximum',
  'yandex_subscription.campaign.budgetType_WEB_OPTIMAL': 'Optimal',
  'yandex_subscription.campaign.budgetType_MINIMAL': 'Minimal',
  'yandex_subscription.campaign.budgetType_MAXIMAL': 'Maximum',
  'yandex_subscription.campaign.budgetType_OPTIMAL': 'Optimal',
  'yandex_subscription.campaign.budgetType_DEFAULT': 'Default',
  'yandex_subscription.campaign.duration': '%1 days (%2)',
  'yandex_subscription.promocode.apply.success': 'Successfully applied',
  'yandex_subscription.need_replenish': 'Not enough funds to launch the campaign. <a href="%1" target="_blank">Add funds</a>',
  'yandex_subscription.slow_processing': 'The campaign creation takes longer than usual, it will be added to the list of campaigns in a few minutes',
  'financial_transaction.yandexsubscription.account_error': "闯将帐户时出错",
  'financial_transaction.yandexsubscription.campaign_error': "failed to create ad campaign",
  'financial_transaction.yandexsubscription.deposit_error': "Failed to add funds to account balance"
}
